module.exports = __webpack_public_path__ + "media/svg-new/icon-geracao-22f58d2d.svg";